<template>
    <section class="page-section section-cards" :style="{ marginLeft: '5%', height: 'auto' }">
        <div class="container">
            <div class="cards-wrapper" :style="{ width: '100%' }">
                <div class="card-element" :style="{ width: '100%' }">
                    <div class="card-wrapper" :style="{ width: '100%' }">
                        <div class="card-content">
                            <h2 style="text-transform: uppercase; color: #6E8496; font-weight: 300; letter-spacing: 2px;">Contact Form for Kingstree West</h2>

                            <div class="tab-content form-tabs" style="height: auto;">

                                <form @submit.prevent="submitForm">
                                    <div class="column-2-inputs">
                                        <div class="form-item">
                                            <input type="text" id="name" v-model="name" placeholder="Name" required>
                                        </div>
                                        <div class="form-item">
                                            <input type="tel" id="phone" v-model="phone" placeholder="Phone" required>
                                        </div>
                                        <div class="form-item" style="grid-column: 1 / -1;">
                                            <input type="email" id="email" v-model="email" placeholder="Email" required>
                                        </div>
                                        <div class="form-item" style="grid-column: 1 / -1;">
                                            <select id="enquiryType" v-model="enquiryType" required>
                                                <option value="" disabled selected>Please select</option>
                                                <option value="General">General</option>
                                                <option value="Vendor">Vendor</option>
                                                <option value="Media">Media</option>
                                                <option value="Public">Public</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                        <div class="form-item" style="grid-column: 1 / -1;">
                                            <input type="text" id="subject" v-model="subject" placeholder="Subject" required>
                                        </div>
                                        <div class="form-item" style="grid-column: 1 / -1;">
                                            <textarea id="message" v-model="message" placeholder="Message" required></textarea>
                                        </div>
                                        <div class="form-item gdpr-item" style="grid-column: 1 / -1;">
                                            <label for="gdpr" class="gdpr-label">
                                                <input type="checkbox" id="gdpr" v-model="gdpr" required>
                                                <span>I accept the <a href="/website-terms-conditions" target="_blank">Website Terms & Conditions</a></span>
                                            </label>
                                        </div>
                                    </div>

                                    <div v-if="submitMessage" :style="{ 
                                        padding: '15px', 
                                        marginBottom: '15px', 
                                        marginTop: '20px',
                                        borderRadius: '4px',
                                        backgroundColor: submitError ? '#f8d7da' : '#d4edda',
                                        color: submitError ? '#721c24' : '#155724',
                                        border: submitError ? '1px solid #f5c6cb' : '1px solid #c3e6cb'
                                    }">
                                        {{ submitMessage }}
                                    </div>

                                    <button type="submit" class="submit-btn" :disabled="isSubmitting">
                                        {{ isSubmitting ? 'SENDING...' : 'SUBMIT' }}
                                        <span class="arrow">→</span>
                                    </button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
    return {
        contentEn: "...",
        name: "",
        phone: "",
        email: "",
        enquiryType: "",
        subject: "",
        message: "",
        gdpr: false,
        isSubmitting: false,
        submitMessage: "",
        submitError: false,
        };
    },
    methods: {
        async submitForm() {
            // Validate form data (English only)
            if (!this.name || !this.phone || !this.email || !this.enquiryType || !this.subject || !this.message || !this.gdpr) {
                this.submitMessage = "Please fill in all fields and accept GDPR terms";
                this.submitError = true;
                return;
            }

            this.isSubmitting = true;
            this.submitMessage = "";
            this.submitError = false;

            try {
                const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

                const response = await fetch(`${API_URL}/api/contact-form-submit`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        name: this.name,
                        phone: this.phone,
                        email: this.email,
                        // Backend serializer expects snake_case enquiry_type (the docstring's
                        // enquiryType is wrong and fails validation).
                        enquiry_type: this.enquiryType,
                        subject: this.subject,
                        message: this.message,
                        gdpr: this.gdpr,
                    }),
                });

                const data = await response.json();

                if (response.ok && data.success) {
                    // Success - reset form
                    this.submitMessage = "Thank you! Your message has been sent successfully. We will contact you soon!";
                    this.submitError = false;

                    // Reset form fields
                    this.name = "";
                    this.phone = "";
                    this.email = "";
                    this.enquiryType = "";
                    this.subject = "";
                    this.message = "";
                    this.gdpr = false;

                    // Clear message after 5 seconds
                    setTimeout(() => {
                        this.submitMessage = "";
                    }, 5000);
                } else {
                    // Error response from server
                    this.submitMessage = data.message || "Error sending message. Please try again.";
                    this.submitError = true;
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                this.submitMessage = "Connection error. Please check your internet connection and try again.";
                this.submitError = true;
            } finally {
                this.isSubmitting = false;
            }
        },
    },
    mounted() {
    }
}
</script>

<style scoped>
@import '@/css/cardSection.css';
@import '@/css/main.css';

.column-2-inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    justify-content: center;
    align-items: start;
}

@media all and (max-width: 991px) {
    .column-2-inputs {
        grid-template-columns: 1fr;
    }
}

.form-item {
    width: 100%;
}

.form-item input[type="text"],
.form-item input[type="email"],
.form-item input[type="tel"],
.form-item select,
.form-item textarea {
    width: 100%;
    padding: 12px 15px;
    border: none;
    border-bottom: 1px solid #E1E5E8;
    background-color: #F6F7F8;
    font-size: 14px;
    color: #6E8496;
    font-family: inherit;
    transition: all 0.3s ease;
}

.form-item input::placeholder,
.form-item textarea::placeholder {
    color: #6E8496;
    opacity: 1;
}

.form-item input:focus,
.form-item select:focus,
.form-item textarea:focus {
    outline: none;
    border-bottom-color: #0058A3;
    background-color: #fff;
}

.form-item select {
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236E8496' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 20px;
    cursor: pointer;
    color: #6E8496;
}

.form-item select option {
    color: #333;
}

.form-item textarea {
    min-height: 120px;
    resize: vertical;
}

.gdpr-item {
    margin-top: 10px;
}

.gdpr-label {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
    color: #6E8496;
}

.gdpr-label input[type="checkbox"] {
    margin-top: 3px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    flex-shrink: 0;
}

.gdpr-label a {
    color: #0058A3;
    text-decoration: none;
}

.gdpr-label a:hover {
    text-decoration: underline;
}

.submit-btn {
    margin-top: 30px;
    padding: 15px 50px;
    background-color: transparent;
    border: 2px solid #0058A3;
    color: #0058A3;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.submit-btn:hover:not(:disabled) {
    background-color: #0058A3;
    color: #fff;
}

.submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.submit-btn .arrow {
    font-size: 18px;
    transition: transform 0.3s ease;
}

.submit-btn:hover:not(:disabled) .arrow {
    transform: translateX(5px);
}

.cards-wrapper {
    height: auto;
}
</style>
